<template>
  <v-app class="pest-vision v-application v-application--is-ltr">
    <app-bar :admin="admin" />
    <main class="pest-vision__main">
      <v-container fluid py-10 class="pest-vision__container">
        <router-view></router-view>
      </v-container>
    </main>
    <bottom-navigation :admin="admin" />
    <scroll-button/>
    <notification/>
    <pending-download/>
    <logged-in-as-other-user-warning />
  </v-app>
</template>

<script>
import { buildApiClient } from '@/libs/api';
import { announcement } from '@/libs/announcement';
import { startDownload } from '@/libs/downloads';
import * as imageValidator from '@/libs/imageValidator';
import { localObjectStorage } from '@/libs/localstorage';
import { cancelPendingRequests } from '@/libs/requestCancellation';

import LoggedInAsOtherUserWarning from '@/components/atoms/LoggedInAsOtherUserWarning';
import AppBar from '@/components/AppBar';
import BottomNavigation from '@/components/BottomNavigation';
import Notification from '@/components/Notification';
import PendingDownload from '@/components/PendingDownload';
import ScrollButton from '@/components/ScrollButton';

export default {
  name: 'app',
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoggedInAsOtherUserWarning,
    PendingDownload,
    BottomNavigation,
    AppBar,
    ScrollButton,
    Notification,
  },
  provide() {
    const api = buildApiClient(this.$http);

    return {
      api,
      announcement,
      // Defined in dist/config.js which is generated at deploy time
      // eslint-disable-next-line no-undef
      appConfig: CONFIG,
      assumeUserIdentity: async (user) => {
        // 切り替え前のユーザーの未解決リクエストの応答が、消去後の一覧に書き戻されないようにする
        cancelPendingRequests();
        this.$store.dispatch('assumeIdentity', user);
        this.$store.dispatch('clearUsers');
        this.$store.dispatch('clearOrganizations');
        try {
          await this.$store.dispatch('getUserInfo');
        } catch (error) {
          // 代理ログイン先を取得できなければ、元のユーザーに戻す
          this.$store.dispatch('resetIdentity');
          throw error;
        }
      },
      downloadAttachment: async (eventId, attachment) => {
        const downloadPath = await api.fetchAttachmentDownloadPath(eventId, attachment);
        startDownload(downloadPath);
      },
      imageValidator,
      localObjectStorage,
      resetIdentity: async () => {
        cancelPendingRequests();
        this.$store.dispatch('resetIdentity');
        this.$store.dispatch('clearUsers');
        this.$store.dispatch('clearOrganizations');
        this.$store.dispatch('clearSensors');
        await this.$store.dispatch('getUserInfo');
      },
      searchTags: async (search) => {
        const response = await this.$http.get(
          '/api/user_info/used_tags',
          { params: { search } },
        );
        return response.data;
      },
    };
  },
};
</script>

<style scoped lang="sass">
@import 'vuetify/src/styles/styles.sass'

.pest-vision
  background-color: #f2f2f2!important

  &__main
    margin-top: -64px
    min-height: 100vh
    padding-bottom: 80px
    padding-top: 64px

  &__container
    min-height: 100vh

  @media (min-width: 1024px)
    &__main
      padding-bottom: 200px

    &__container
      padding-left: calc(#{$container-padding-x} * 5)
      padding-right: calc(#{$container-padding-x} * 5)
</style>
